/* tslint:disable */
/* eslint-disable */
/**
 * Corrigo API
 * fejlesztői
 *
 * The version of the OpenAPI document: 1.5.2
 * Contact: kerezsigergely@infobex.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
/**
 *
 */
export class SubscriptionsApi extends runtime.BaseAPI {
    /**
     * Havi statisztika lekérdezése [ID: GetBillingReport]
     */
    getBillingReportRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['date'] == null) {
                throw new runtime.RequiredError('date', 'Required parameter "date" was null or undefined when calling getBillingReport().');
            }
            const queryParameters = {};
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            if (requestParameters['date'] != null) {
                queryParameters['date'] = requestParameters['date'];
            }
            if (requestParameters['format'] != null) {
                queryParameters['format'] = requestParameters['format'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/subscriptions/overview`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Havi statisztika lekérdezése [ID: GetBillingReport]
     */
    getBillingReport(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getBillingReportRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Lejáró előfizetések lekérdezése [ID: GetExpiringSubscriptions]
     * @deprecated
     */
    getExpiringSubscriptionsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['renewed'] == null) {
                throw new runtime.RequiredError('renewed', 'Required parameter "renewed" was null or undefined when calling getExpiringSubscriptions().');
            }
            if (requestParameters['expires_in'] == null) {
                throw new runtime.RequiredError('expires_in', 'Required parameter "expires_in" was null or undefined when calling getExpiringSubscriptions().');
            }
            const queryParameters = {};
            if (requestParameters['renewed'] != null) {
                queryParameters['renewed'] = requestParameters['renewed'];
            }
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            if (requestParameters['format'] != null) {
                queryParameters['format'] = requestParameters['format'];
            }
            if (requestParameters['expires_in'] != null) {
                queryParameters['expires_in'] = requestParameters['expires_in'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/subscriptions/expiring`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Lejáró előfizetések lekérdezése [ID: GetExpiringSubscriptions]
     * @deprecated
     */
    getExpiringSubscriptions(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getExpiringSubscriptionsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get subscriptions [ID: GetSubscriptions]
     */
    getSubscriptionsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['user_id'] != null) {
                queryParameters['user_id'] = requestParameters['user_id'];
            }
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            if (requestParameters['login_id'] != null) {
                queryParameters['login_id'] = requestParameters['login_id'];
            }
            if (requestParameters['login_name'] != null) {
                queryParameters['login_name'] = requestParameters['login_name'];
            }
            if (requestParameters['plan_id'] != null) {
                queryParameters['plan_id'] = requestParameters['plan_id'];
            }
            if (requestParameters['created_after'] != null) {
                queryParameters['created_after'] = requestParameters['created_after'];
            }
            if (requestParameters['created_before'] != null) {
                queryParameters['created_before'] = requestParameters['created_before'];
            }
            if (requestParameters['effective_after'] != null) {
                queryParameters['effective_after'] = requestParameters['effective_after'];
            }
            if (requestParameters['effective_before'] != null) {
                queryParameters['effective_before'] = requestParameters['effective_before'];
            }
            if (requestParameters['expires_after'] != null) {
                queryParameters['expires_after'] = requestParameters['expires_after'];
            }
            if (requestParameters['expires_before'] != null) {
                queryParameters['expires_before'] = requestParameters['expires_before'];
            }
            if (requestParameters['change_after'] != null) {
                queryParameters['change_after'] = requestParameters['change_after'];
            }
            if (requestParameters['change_before'] != null) {
                queryParameters['change_before'] = requestParameters['change_before'];
            }
            if (requestParameters['sort_by'] != null) {
                queryParameters['sort_by'] = requestParameters['sort_by'];
            }
            if (requestParameters['sort_direction'] != null) {
                queryParameters['sort_direction'] = requestParameters['sort_direction'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            if (requestParameters['active'] != null) {
                queryParameters['active'] = requestParameters['active'];
            }
            if (requestParameters['has_followup'] != null) {
                queryParameters['has_followup'] = requestParameters['has_followup'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/subscriptions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get subscriptions [ID: GetSubscriptions]
     */
    getSubscriptions() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getSubscriptionsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetSubscriptionsByUserId]
     * @deprecated
     */
    getSubscriptionsByUserIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['user_id'] == null) {
                throw new runtime.RequiredError('user_id', 'Required parameter "user_id" was null or undefined when calling getSubscriptionsByUserId().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/users/{user_id}/subscriptions`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['user_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetSubscriptionsByUserId]
     * @deprecated
     */
    getSubscriptionsByUserId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSubscriptionsByUserIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Előfizetés lejáratának szerkesztése [ID: ModifyExpirationDate]
     */
    modifyExpirationDateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subscription_id'] == null) {
                throw new runtime.RequiredError('subscription_id', 'Required parameter "subscription_id" was null or undefined when calling modifyExpirationDate().');
            }
            if (requestParameters['ModifyExpirationDateRequest'] == null) {
                throw new runtime.RequiredError('ModifyExpirationDateRequest', 'Required parameter "ModifyExpirationDateRequest" was null or undefined when calling modifyExpirationDate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/subscriptions/{subscription_id}`.replace(`{${"subscription_id"}}`, encodeURIComponent(String(requestParameters['subscription_id']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['ModifyExpirationDateRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Előfizetés lejáratának szerkesztése [ID: ModifyExpirationDate]
     */
    modifyExpirationDate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.modifyExpirationDateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Előfizetési idő átcsoportosítása [ID: ReallocateSubscriptionTime]
     */
    reallocateSubscriptionTimeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/subscriptions/reallocate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['ReallocateSubscriptionTimeRequest'],
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Előfizetési idő átcsoportosítása [ID: ReallocateSubscriptionTime]
     */
    reallocateSubscriptionTime() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.reallocateSubscriptionTimeRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Előfizetés terminálása [ID: TerminateSubscription]
     */
    terminateSubscriptionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subscription_id'] == null) {
                throw new runtime.RequiredError('subscription_id', 'Required parameter "subscription_id" was null or undefined when calling terminateSubscription().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/subscriptions/{subscription_id}`.replace(`{${"subscription_id"}}`, encodeURIComponent(String(requestParameters['subscription_id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['TerminateSubscriptionRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Előfizetés terminálása [ID: TerminateSubscription]
     */
    terminateSubscription(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.terminateSubscriptionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
 * @export
 */
export const GetBillingReportFormatEnum = {
    json: 'json',
    csv: 'csv'
};
/**
 * @export
 */
export const GetExpiringSubscriptionsFormatEnum = {
    JSON: 'JSON',
    CSV: 'CSV'
};
/**
 * @export
 */
export const GetSubscriptionsSortByEnum = {
    effective_date: 'effective_date',
    expiration_date: 'expiration_date',
    created: 'created'
};
